// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;But my eyes are turned to you, Lord God;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;in you I take refuge; do not leave me defenceless.<br> </p> </div></div>";
// Exports
module.exports = code;